import Profile from "@sentrei/common/models/Profile";

declare namespace Member {
  export type Collections = "spaces" | "rooms";

  export type EditableFields = {
    role: "admin" | "moderator" | "viewer";
  };

  interface Fields extends EditableFields {
    joined: firebase.firestore.FieldValue;
  }

  export interface Request extends Fields, Profile.Get {}

  export interface Response extends Fields, Profile.Get {
    joined: firebase.firestore.Timestamp;
  }

  export interface Get extends Omit<Response, "joined"> {
    joined: string;
  }

  export interface Snapshot extends Get {
    snap: firebase.firestore.DocumentSnapshot;
  }
}

export default Member;
